import { useQuery } from "@tanstack/react-query";
import { UserProfileModel } from "../../types/UserProfile";
import { axiosCoreInstance } from "src/config/axios";

export const RQ_USER_PROFILE_DETAILS_KEY = "USER_PROFILE_DETAILS_KEY";

export type UserProfileDetailsResponse = UserProfileModel;

export const useProfileUserDetails = () => {
    return useQuery({
        queryKey: [RQ_USER_PROFILE_DETAILS_KEY],
        queryFn: async (): Promise<UserProfileDetailsResponse | null> => {
            const resp = await axiosCoreInstance.get(`api/user/profile`);

            return resp?.data || null;
        },
        enabled: false,
    });
};
